const services = [
  { name: 'Basic Portfolio Site', tier: 'tier-basic', tierLabel: 'Basic', price: '₹8,000 – ₹15,000', delivery: '3–5 days', includes: '1–3 pages, responsive, contact form' },
  { name: 'Professional Business Site', tier: 'tier-standard', tierLabel: 'Standard', price: '₹25,000 – ₹45,000', delivery: '7–12 days', includes: '5–8 pages, SEO, blog, animations' },
  { name: 'Business+ Website', tier: 'tier-premium', tierLabel: 'Premium', price: '₹50,000 – ₹90,000', delivery: '14–20 days', includes: '10+ pages, CMS, payment, custom UI' },
  { name: 'E-commerce Store', tier: 'tier-enterprise', tierLabel: 'Enterprise', price: '₹70,000 – ₹1,50,000', delivery: '20–35 days', includes: 'Full store, admin panel, analytics' },
  { name: 'Landing Page', tier: 'tier-basic', tierLabel: 'Basic', price: '₹12,000 – ₹22,000', delivery: '3–6 days', includes: 'Single page, conversion focused' },
  { name: 'Web App Development', tier: 'tier-enterprise', tierLabel: 'Enterprise', price: '₹1,00,000 – ₹3,00,000', delivery: '30–60 days', includes: 'React/Node, DB, auth, API' },
  { name: 'Website Redesign / UI-UX', tier: 'tier-standard', tierLabel: 'Standard', price: '₹20,000 – ₹55,000', delivery: '7–15 days', includes: 'Figma mockups, new theme, responsive' },
  { name: 'Website Maintenance', tier: 'tier-standard', tierLabel: 'Standard', price: '₹3,000 – ₹8,000/mo', delivery: 'Ongoing', includes: 'Updates, backups, performance' },
  { name: 'SEO Optimization', tier: 'tier-standard', tierLabel: 'Standard', price: '₹8,000 – ₹20,000', delivery: '5–10 days', includes: 'On-page SEO, meta, speed, sitemap' },
];

export default function WebDev() {
  return (
    <div className="d-card">
      <div className="d-ctitle">Web Design & Development — Service Packages</div>
      <table className="d-table">
        <thead><tr><th>Package / Service</th><th>Type</th><th>Price Range</th><th>Delivery</th><th>Includes</th><th>Status</th></tr></thead>
        <tbody>
          {services.map(s => (
            <tr key={s.name}>
              <td><b style={{ color: '#1a1a1a' }}>{s.name}</b></td>
              <td><span className={`pricing-tier ${s.tier}`}>{s.tierLabel}</span></td>
              <td style={{ color: '#1800ad', fontWeight: 600 }}>{s.price}</td>
              <td>{s.delivery}</td>
              <td style={{ fontSize: 11 }}>{s.includes}</td>
              <td><span className="d-st s-paid">Active</span></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: 14, background: '#eef0ff', padding: 12, borderRadius: 8, fontSize: 13, color: '#3d3555', border: '1px solid #c5caff' }}>
        💡 <b>LathiNyx DevLabs</b> pricing is flexible. Custom quotes available for complex projects. Contact via <a href="https://lathinyxdevlabs.com" target="_blank" rel="noreferrer" style={{ color: '#1800ad' }}>lathinyxdevlabs.com</a>
      </div>
    </div>
  );
}
